import { ROUTES } from 'src/config/routes';
import { IOptions } from './interface';

export const Teacher: IOptions[] = [
	{ label: 'Tutoria', link: ROUTES.TutorNotes },
	{ label: 'Autoavaliação e Interpares', link: ROUTES.teacherLaunchNotes },
	{ label: 'Morfofuncional', link: ROUTES.LaunchMorphofunctionalNotes },
	{ label: 'Cognitiva', link: ROUTES.throwCognitiveNotes },
	{ label: 'Avaliações', link: ROUTES.registerEvaluation },
	{ label: 'Problemas', link: ROUTES.parameterizeProblem },
	{ label: 'Relatórios', link: ROUTES.reportsPage },
	{ label: 'Notas Gerais', link: ROUTES.generalNotes },
	{ label: 'Notas Tutoria', link: ROUTES.tutoringGrades },
	{ label: 'Desempenho Tutoria', link: ROUTES.consultPerformanceMentoringProgress },
	{ label: 'Inconsistências', link: ROUTES.inconsistencies },
];

export const Student: IOptions[] = [
	{ label: 'Consultar Notas', link: ROUTES.consultNotes },
	{ label: 'Calendário de Aulas', link: ROUTES.studentCalendar },
	{ label: 'Lançamento de Notas', link: ROUTES.noteRelease },
	{ label: 'História do Problema', link: ROUTES.problemHistory },
];
